import Brand from './Brand';
import { Link } from 'react-router-dom';
import React from 'react';
import { Calendar, Clock, MessageSquare, Gift, LogOut, X, BarChart3 } from 'lucide-react';
import { Button } from './ui/button';

const AdminSidebar = ({ activeTab, setActiveTab, onLogout, isMobileOpen, setIsMobileOpen }) => {
  const menuItems = [
    { id: 'dashboard', icon: BarChart3, label: 'Tableau de bord', emoji: '📊' },
    { id: 'appointments', icon: Calendar, label: 'Rendez-vous', emoji: '📅' },
    { id: 'slots', icon: Clock, label: 'Planning', emoji: '🕐' },
    { id: 'reviews', icon: MessageSquare, label: 'Avis', emoji: '⭐' },
    { id: 'loyalty', icon: Gift, label: 'Fidélité', emoji: '🎁' },
  ];

  const handleItemClick = (id) => {
    setActiveTab(id);
    if (isMobileOpen) {
      setIsMobileOpen(false);
    }
  };

  return (
    <>
      {/* Overlay pour mobile */}
      {isMobileOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside 
        className={`fixed top-0 left-0 h-full w-72 bg-gradient-to-b from-amber-50 to-white border-r border-amber-200 shadow-xl z-50 transition-transform duration-300 ease-in-out ${
          isMobileOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        {/* Header */}
        <div className="p-6 border-b border-amber-200 bg-gradient-to-r from-amber-500 to-amber-600">
          <div className="flex items-center justify-between">
            <div>
              <Link to="/" aria-label="Retour au site"><Brand /></Link>
              <p className="text-amber-100 text-sm font-light">L’ESPACE ADMIN</p>
            </div>
            <button
              aria-label="Fermer le menu" onClick={() => setIsMobileOpen(false)}
              className="lg:hidden text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            
            return (
              <button
                key={item.id} aria-current={isActive ? "page" : undefined}
                onClick={() => handleItemClick(item.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                  isActive
                    ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-lg shadow-amber-500/30'
                    : 'text-gray-700 hover:bg-amber-100/50 hover:text-amber-700'
                }`}
              >
                <Icon size={19} aria-hidden="true" />
                <span className="font-medium">{item.label}</span>
                {isActive && (
                  <div className="ml-auto w-2 h-2 rounded-full bg-white animate-pulse" />
                )}
              </button>
            );
          })}
        </nav>

        {/* Footer avec déconnexion */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-amber-200 bg-white">
          <Button
            onClick={onLogout}
            variant="outline"
            className="w-full justify-start gap-3 border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300"
          >
            <LogOut className="w-4 h-4" />
            Déconnexion
          </Button>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
